import {
  UserGetDirectRequest,
  UserGetDirectResponse,
} from '../../../types/user'
import { useApiPostQuery } from '../useApi'

export const useUserDirectChck = (requestData: UserGetDirectRequest) => {
  return useApiPostQuery<UserGetDirectResponse>(
    '/user/getDirectChck',
    ['userDirectWrong', requestData.USER_ID],
    requestData,
    !!requestData.USER_ID,
    {
      staleTime: 0,
      cacheTime: 1000 * 10,
      refetchOnMount: 'always',
    }
  )
}
